import { render, staticRenderFns } from "./SignatureModal.vue?vue&type=template&id=2ff0a2bf&scoped=true&"
import script from "./SignatureModal.vue?vue&type=script&lang=js&"
export * from "./SignatureModal.vue?vue&type=script&lang=js&"
import style0 from "./SignatureModal.vue?vue&type=style&index=0&id=2ff0a2bf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff0a2bf",
  null
  
)

export default component.exports